import React,{ useState } from 'react'
import { message } from 'antd';
import { useHistory } from 'react-router-dom'
import { url, header } from "../Constent/Constant";

import Logo from "../Assets/Logo.JPG";
import LiveSVG from "../Assets/boxmoving.svg";

const Login = () => {
    const [Email, setEmail] = useState('')
    const [Password, setPassword] = useState('')
    const history = useHistory()

    const OnLogin = () => {
       if(Email === '' && Password === ''){
           message.error('Fill Fields Correctly')
       }else{
        fetch(`${url}/admin/adminLogin`, {
            method: 'POST',
            body: JSON.stringify({
              email:Email,
              password:Password
            }),
            headers: header
          })
            .then(res => res.json())
            .then(data => {
              console.log(data)
              if (data.message === 'Success') {
                localStorage.setItem('MS-Login',true)
                localStorage.setItem('MS-AdminId',data.doc._id)
                history.push('/Home')
              }
            })
       }
    }

    return (
        <div className='Login-container'>
            <div className='Info'>
                <img className='Logo' src={Logo} alt='Logo' />
                <img className='Live-Svg' src={LiveSVG} alt='liveSvg' draggable='false' />
                <p>" Life is life a bicycle. To keep you balance you must keep moving "</p>
            </div>
            <div className='Form'>
            <img src={Logo} alt='Logo' />
                <h2>LOGIN</h2>
                <input value={Email} onChange={e => setEmail(e.target.value)} placeholder='Email...' />
                <input type='password' value={Password} onChange={e => setPassword(e.target.value)} placeholder='Password...' />
                <button onClick={OnLogin}>Login</button>
            </div>
        </div>
    )
}

export default Login
